const vendorSidebarItems = [
  {
    key: "vendor-assignments",
    title: "Penugasan",
    icon: "ri-home-smile-line",
    to: { name: "vendor-assignments" },
  },
  {
    key: "vendor-progress-report",
    title: "Laporan Progres",
    icon: "ri-file-excel-2-line",
    to: { name: "vendor-progress-report" },
  },
];

export default vendorSidebarItems;
